import { Grid2, Grow, Typography } from '@mui/material';
import React from 'react';
import * as styles from './headboard2.module.scss';
import Button2 from '../../atoms/button2/button2';
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';

export interface IHeadboard2Props {
    title?: string;
    subtitle?: string;
    image?: string;
    description?: any;
    btnLabel?: string;
    redirection?: string;
    breadcrumb?: string;
}

const Headboard2 = ({
    subtitle,
    title,
    description,
    btnLabel,
    redirection,
    image,
    breadcrumb,
}: IHeadboard2Props) => {
    return (
        <Grow in timeout={500} appear>
            <Grid2 container className={styles.o_headboard2}>
                <Grid2 size={{ xs: 12, md: 6 }} className={styles.o_headboard2__info}>
                    <div className={styles.o_headboard2__container}>
                        {breadcrumb && <Breadcrumb content={breadcrumb} />}
                        {subtitle && (
                            <span className={styles.o_headboard2__subtitle}>
                                {subtitle}
                            </span>
                        )}
                        {title && (
                            <Typography
                                component="h1"
                                className={styles.o_headboard2__title}
                                dangerouslySetInnerHTML={{
                                    __html: title,
                                }}
                            />
                        )}
                        {description && (
                            <Typography
                                component="p"
                                className={styles.o_headboard2__desc}
                            >
                                {description}
                            </Typography>
                        )}
                        {redirection && btnLabel && (
                            <Button2
                                label={btnLabel}
                                redirect={redirection}
                                classname={styles.o_headboard2__btn}
                            />
                        )}
                    </div>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }} className={styles.o_headboard2__img}>
                    <img src={image} alt="" />
                </Grid2>
            </Grid2>
        </Grow>
    );
};

export default Headboard2;
